export const CADASTRAMENTO_REQUEST = "CADASTRAMENTO_REQUEST";
export const CADASTRAMENTO_SUCCESS = "CADASTRAMENTO_SUCCESS";
export const CADASTRAMENTO_FAIL = "CADASTRAMENTO_FAIL";
